import { fetchPeriodData, fetchPeriodCoinsList, fetchComparePeriod } from "@/Groups/Scanner/private/api/periodData";

const state = () => ({
  periods: [],
  isReady: false,
  isOpened: true,
  isLoading: false,
  idActivePeriod: null,
  comparePeriod: [],
});

const actions = {
  async updatePeriodList({ state, commit }, { custom_tag_id, base_coin_id, tag_id, usd }){
    try{
      let params = {};
      if(base_coin_id) params['base_coin_id'] = base_coin_id;
      if(custom_tag_id) params['custom_tag_id'];
      if(usd) params['usd'] = true;
      if(tag_id) params['tag_id'] = tag_id;
      commit('SET_LOADING_FLAG', true);
      const data = await fetchPeriodData(params);
      commit('SET_READY_FLAG', true);
      commit('SET_DATA', data);
      return data;
    } catch(err){
      console.warn('Ошибка', err)
    } finally{
      commit('SET_LOADING_FLAG', false);
    }
  },

  async loadCoinsList({ state, commit }, params){
    try{
      commit('SET_ACTIVE_PERIOD_ID', params.period);
      return await fetchPeriodCoinsList(params);
    } catch(err){
      console.warn('Ошибка', err)
    } finally{
      commit('SET_LOADING_FLAG', false);
    }
  },

  async loadCompare({ state, commit }, params) {
    try {
      commit('SET_LOADING_FLAG', true);
      const data = await fetchComparePeriod(params);
      commit('SET_COMPARE_PERIOD', data);
      return data;
    } catch (err) {
      console.warn('Ошибка при загрузке сравнения импульсов:', err);
    } finally {
      commit('SET_LOADING_FLAG', false);
    }
  },

  async resetCompare({ commit }) {
    commit('SET_COMPARE_PERIOD', null);
  },

  setActivePeriodId({ commit }, id) {
    commit('SET_ACTIVE_PERIOD_ID', id);
  },

  toggleOpended({ state, commit }){
    const status = (state.isOpened) ? false : true;
    commit('SET_OPENED_LIST_FLAG', status);
  },

  resetPeriod({ commit }) {
    commit('SET_DATA', []);
    commit('SET_COMPARE_PERIOD', []);
    commit('SET_READY_FLAG', false);
    commit('SET_LOADING_FLAG', false);
    commit('SET_OPENED_LIST_FLAG', true);
    commit('SET_ACTIVE_PERIOD_ID', null);
  },
};

const mutations = {
  SET_DATA(state, data){ state.periods = data; },

  SET_COMPARE_PERIOD(state, data) { state.comparePeriod = data; },

  SET_READY_FLAG(state, status = true){ state.isReady = status; },

  SET_LOADING_FLAG(state, status){ state.isLoading = status; },

  SET_OPENED_LIST_FLAG(state, status){ state.isOpened = status; },

  SET_ACTIVE_PERIOD_ID(state, id){ state.idActivePeriod = id; }
};

const getters = {
  //Возвращает весь список периодов
  allPeriods: (state) => state.periods,
  //Флаг, указывающий, были ли периоды успешно загружены
  isPeriodReady: (state) => state.isReady,
  //Флаг, указывающий, выполняется ли загрузка периодов в данный момент
  isPeriodLoading: (state) => state.isLoading,
  //Возвращает период по его ID, если найден, иначе null
  getPeriodById: (state) => (id) => state.periods.find(p => p.id === id) || null,
  //Возвращает количество загруженных периодов
  periodsCount: (state) => state.periods.length,
  //Развернут ли список периодов
  isOpenedList: (state) => state.isOpened,
  //Получить активный ID периода
  activePeriodId: (state) => state.idActivePeriod,
  //Получить список compare impulse
  getComparePeriod: (state) => state.comparePeriod,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
